import React, { Component, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { connect } from "react-redux";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import printed from "../../Redux/APIs/CompanyAPIs/printed";
import { format } from "date-fns";

class Letter extends Component {
  render() {
    return (
      <page size="A4" style={{ marginLeft: "0px", paddingLeft: "1.6cm" }}>
        <img
          className="mt-3 ml-5 logoImage"
          src={require("../../Assets/images/print-logo.png").default || require("../../Assets/images/print-logo.png")}
          alt="logo"
        />
        <div
          className="l-organization-details ml-5 pt-5"
          style={{ marginTop: "101px" }}
        >
          <p>{this.props?.name}</p>
          {this.props.newAddress?.split(",").map((add, i) => (
            <p key={i}>{add}</p>
          ))}
        </div>
        <div className="l-date-details ml-5 pt-5 mt-3">
          <p>{format(new Date(), "dd MMM yyyy")}</p>
        </div>
        <h4 className="letter-heading font-weight-bold pt-3 ml-5">
          Re: Notification of change of address
        </h4>
        <div className="letter-content ml-5 mt-4">
          <p>Hey {this.props?.firstName}</p>
          <p className="pt-3">
            Please find your change of address letter template/s for you to sign
            and send. As you have notified a financial institute, they require
            your signature in order to process your change of address.
          </p>
          <p className="pt-3">
            Please ensure that all the information on your letter template is
            correct and don't forget to fill out any additional information.
          </p>
          <p className="pt-4">Yours Sincerely,</p>
          <p>The Moveinout Team</p>
        </div>
      </page>
    );
  }
}

const SIGNATURE_SERVICES = ["Premium Bonds", "Bank", "Private Pension"];

const IntructionLetter = (props) => {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => props?.printed(props?.id, props?.requiredAPI),
  });

  if (!SIGNATURE_SERVICES.includes(props.serviceName)) {
    return null;
  }

  return (
    <div>
      <Button icon={<PrinterOutlined />} size="small" onClick={handlePrint}>
        Instruction Letter
      </Button>
      <div style={{ display: "none" }}>
        <Letter
          ref={componentRef}
          name={props?.name}
          newAddress={props?.newAddress}
          firstName={props?.firstName}
          companyName={props?.companyName}
          serviceName={props?.serviceName}
        />
      </div>
    </div>
  );
};

const mapDispatchToProps = { printed };
export default connect(null, mapDispatchToProps)(IntructionLetter);
